import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LogoHyundai from "../../images/assets/hyundai-logo.webp";
import "./css/menu.css";
import cartIcon from "../../images/cartIcon.png";
import carIcon from "../../images/car-icon.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Form, FormControl, InputGroup, Modal, ModalTitle } from 'react-bootstrap';
import {CartBuy} from "./CartBuy"

function MenuCheckout() {

  return (
    <Fragment >
      <div className="fondo"></div>
      <header className="d-none d-sm-block  ">
        <Container className="container-custom " >
          <Row className="justify-content-between ">
            <div className="barra-menu ">
              <ul className="flex-wrap">
                {/*<li >
                  <Link to="/terminos-y-condiciones" className="text-reset">
                    Términos y condiciones
                  </Link>
                </li>*/}
                <li>|</li>
                <li >
                  <Link to="/politica-privacidad" className="text-reset">
                    Políticas de privacidad y Protección de datos
                  </Link>
                </li>
                <li>|</li>
                <li>
                  <Link to="/mercado-valores" className="text-reset">
                    Mercado de valores
                  </Link>
                </li>
                <li>|</li>
                <li >
                  <Link to="/politica-calidad" className="text-reset">
                    Política de calidad
                  </Link>
                </li>
                <li>|</li>
                <li >
                  <Link to="/mision-vision" className="text-reset">
                    Misión y Visión
                  </Link>
                </li>
                <li>|</li>
                <li>
                  <Nav.Link
                    href="https://hyundai.hiringroom.com/jobs"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="nav-link-barra text-reset"
                  >
                    Trabaja con nosotros
                  </Nav.Link>
                </li>
              </ul>
            </div>
          </Row>
        </Container>
      </header>
      <div>
        <Navbar expand="lg" className="menu-navbar" >
        <Row md={12}>
        <Col >
          <Navbar.Brand as={Link} to="/" className="menu-logo-start">
            <LazyLoadImage src={LogoHyundai} alt="Logo Hyundai" width={19} height={60} />
          </Navbar.Brand>
          </Col>
            <Col >
              <div className="grid-header-repuestos-dos">
                <h1 className="Titulo-repeustos">Tienda de Partes & Accesorios Originales Hyundai</h1>
              </div>
            </Col>
            <Col >
              <div className="grid-header-repuestos-dos">
                <LazyLoadImage src={carIcon} alt="Logo Carro" className="car-icon" />
              </div>
            </Col>
          </Row>

        </Navbar>
      </div>

    </Fragment>
  );
}
export default MenuCheckout; 